
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import { Route } from "react-router-dom";
import classNames from "classnames";
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";
import EmptyInvoiceListView from 'components/emptyInvoice/EmptyInvoiceListView';
import AddEmptyInvoiceView from 'components/emptyInvoice/AddEmptyInvoiceView';
import DeleteEmptyInvoiceView from 'components/emptyInvoice/DeleteEmptyInvoiceView';
import InvoiceListView from 'components/invoice/InvoiceListView';
import CreateInvoiceView from 'components/invoice/CreateInvoiceView';
import InvoiceInfoView from 'components/invoice/InvoiceInfoView';
import EditInvoiceView from 'components/invoice/EditInvoiceView';
import AllowanceListView from 'components/allowance/AllowanceListView';
import CreateManualAllowanceView from 'components/allowance/CreateManualAllowanceView';
import PrizedInvoiceListView from 'components/prizecheck/PrizedInvoiceListView';
import CheckPrizeView from 'components/prizecheck/CheckPrizeView';
import TurnkeyUploadLogListView from 'components/turnkeyuploadlog/TurnkeyUploadLogListView';
import AllowanceInfoView from 'components/allowance/AllowanceInfoView';
import CreateAllowanceView from 'components/allowance/CreateAllowanceView';

class HomeView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isShowMenuBar: false,
        };

        this.toggleMenuBar = this.toggleMenuBar.bind(this);
    }

    toggleMenuBar(isShowMenuBar) {

        this.setState({
            isShowMenuBar: isShowMenuBar
        });
    }

    render() {
    	return (
            <div className="content">

                <div
                    className={classNames('left-panel', {
                       'show-menu': this.state.isShowMenuBar
                    })}
                    onMouseLeave={() => this.toggleMenuBar(false)}
                >
                    <div className="scroll-content">
                        <section className="nav">
                            <h6 className="title"><i className="zmdi zmdi-file-text title-icon" /> 開立發票管理</h6>
                            <ul className="nav-list">
                                <li className={classNames('nav-item', {
                                   'active': CupoyRouter.includes(CupoyRouter.STATES.INVOICE_LIST)
                                })}>
                                    <CupoySrefView 
                                        statename={CupoyRouter.STATES.INVOICE_LIST}
                                        params={{
                                            page: 1,
                                        }}
                                    >
                                        開立發票列表
                                    </CupoySrefView>
                                </li>
                                <li className={classNames('nav-item', {
                                   'active': CupoyRouter.includes(CupoyRouter.STATES.CREATE_INVOICE)
                                })}>
                                    <CupoySrefView 
                                        statename={CupoyRouter.STATES.CREATE_INVOICE}
                                    >
                                        手動開立發票
                                    </CupoySrefView>
                                </li>
                                <li className={classNames('nav-item', {
                                   'active': CupoyRouter.includes(CupoyRouter.STATES.TURNKEYUPLOADLOG_LIST)
                                })}>
                                    <CupoySrefView 
                                        statename={CupoyRouter.STATES.TURNKEYUPLOADLOG_LIST}
                                        params={{
                                            page: 1,
                                        }}
                                    >
                                        已上傳發票列表
                                    </CupoySrefView>
                                </li>
                            </ul>
                        </section>    
                        <section className="nav">
                            <h6 className="title"><i className="zmdi zmdi-file-text title-icon" /> 空白發票管理</h6>
                            <ul className="nav-list">
                                <li className={classNames('nav-item', {
                                   'active': CupoyRouter.includes(CupoyRouter.STATES.EMPTYINVOICE_LIST)
                                })}>
                                    <CupoySrefView 
                                        statename={CupoyRouter.STATES.EMPTYINVOICE_LIST}
                                        params={{
                                            page: 1,
                                        }}
                                    >
                                        空白發票列表
                                    </CupoySrefView>
                                </li>
                                <li className={classNames('nav-item', {
                                   'active': CupoyRouter.includes(CupoyRouter.STATES.ADD_EMPTYINVOICE)
                                })}>
                                    <CupoySrefView 
                                        statename={CupoyRouter.STATES.ADD_EMPTYINVOICE}
                                    >
                                        上架空白發票
                                    </CupoySrefView>
                                </li>                
                                <li className={classNames('nav-item', {
                                   'active': CupoyRouter.includes(CupoyRouter.STATES.DEL_EMPTYINVOICE)
                                })}>
                                    <CupoySrefView 
                                        statename={CupoyRouter.STATES.DEL_EMPTYINVOICE}
                                    >
                                        下架空白發票
                                    </CupoySrefView>
                                </li>                                                     
                            </ul>
                        </section>            
                        <section className="nav">
                            <h6 className="title"><i className="zmdi zmdi-file-text title-icon" /> 中獎發票管理</h6>
                            <ul className="nav-list">
                                <li className={classNames('nav-item', {
                                   'active': CupoyRouter.includes(CupoyRouter.STATES.PRIZEDINVOICE_LIST)
                                })}>
                                    <CupoySrefView 
                                        statename={CupoyRouter.STATES.PRIZEDINVOICE_LIST}
                                        params={{
                                            page: 1,
                                        }}
                                    >
                                        中獎發票列表
                                    </CupoySrefView>
                                </li>
                                <li className={classNames('nav-item', {
                                   'active': CupoyRouter.includes(CupoyRouter.STATES.CHECK_PRIZE)
                                })}>
                                    <CupoySrefView 
                                        statename={CupoyRouter.STATES.CHECK_PRIZE}
                                    >
                                        上傳對獎清冊
                                    </CupoySrefView>
                                </li>                
                            </ul>
                        </section>
                        <section className="nav">
                            <h6 className="title"><i className="zmdi zmdi-file-text title-icon" /> 折讓單管理</h6>
                            <ul className="nav-list">
                                <li className={classNames('nav-item', {
                                   'active': CupoyRouter.includes(CupoyRouter.STATES.ALLOWANCE_LIST)
                                })}>
                                    <CupoySrefView 
                                        statename={CupoyRouter.STATES.ALLOWANCE_LIST}
                                        params={{
                                            page: 1,
                                        }}
                                    >
                                        折讓單列表
                                    </CupoySrefView>
                                </li>
                                {/* <li className={classNames('nav-item', {
                                   'active': CupoyRouter.includes(CupoyRouter.STATES.CREATE_MANUAL_ALLOWANCE)
                                })}>
                                    <CupoySrefView 
                                        statename={CupoyRouter.STATES.CREATE_MANUAL_ALLOWANCE}
                                    >
                                        開立折讓單
                                    </CupoySrefView>
                                </li> */}

                            </ul>
                        </section>                                  

                    </div>
                </div>

                <div className="right-panel">
                    <div className="menu-trigger" onMouseEnter={() => this.toggleMenuBar(true)}><i className="zmdi zmdi-menu"></i></div>
                    <div className="right-panel-content">
                        <Route path={CupoyRouter.PATHS.EMPTYINVOICE_LIST} component={EmptyInvoiceListView} exact/>
                        <Route path={CupoyRouter.PATHS.ADD_EMPTYINVOICE} component={AddEmptyInvoiceView} exact/>
                        <Route path={CupoyRouter.PATHS.DEL_EMPTYINVOICE} component={DeleteEmptyInvoiceView} exact/>
                        <Route path={CupoyRouter.PATHS.INVOICE_LIST} component={InvoiceListView} exact/>
                        <Route path={CupoyRouter.PATHS.CREATE_INVOICE} component={CreateInvoiceView} exact/>
                        <Route path={CupoyRouter.PATHS.INVOICE_INFO} component={InvoiceInfoView} exact/>
                        <Route path={CupoyRouter.PATHS.EDIT_INVOICE} component={EditInvoiceView} exact/>                        
                        <Route path={CupoyRouter.PATHS.ALLOWANCE_INFO} component={AllowanceInfoView} exact/>
                        <Route path={CupoyRouter.PATHS.ALLOWANCE_LIST} component={AllowanceListView} exact/>
                        <Route path={CupoyRouter.PATHS.CREATE_ALLOWANCE} component={CreateAllowanceView} exact/>
                        <Route path={CupoyRouter.PATHS.CREATE_MANUAL_ALLOWANCE} component={CreateManualAllowanceView} exact/>                        
                        <Route path={CupoyRouter.PATHS.PRIZEDINVOICE_LIST} component={PrizedInvoiceListView} exact/>
                        <Route path={CupoyRouter.PATHS.CHECK_PRIZE} component={CheckPrizeView} exact/>
                        <Route path={CupoyRouter.PATHS.TURNKEYUPLOADLOG_LIST} component={TurnkeyUploadLogListView} exact/>
                    </div>
                </div>
            </div>
    	);
    }
}

const mapStateToProps = function(state) {
    return {
        history: state.web.history,
    };
};

const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(HomeView);


// WEBPACK FOOTER //
// ./src/components/HomeView.js